import { addVehicle } from "action/garage/addVehicle";
import { openModal } from "action/modal/openModal";
import { IFitmentOptionsDetails } from "api/interfaces/get-page-details/common/category-page.type";
import PAImage from "component/design-system/images/PAImage";
import PAText from "component/design-system/typography/PAText/PAText";
import VehicleSelectorForm from "component/vehicle-form/VehicleSelectorForm";
import { MAKE_MODEL_YEAR, YEAR_MAKE_MODEL } from "component/vehicle-form/constants";
import useScreenSize from "hoc/useScreenSize";
import { RootState } from "interfaces/generics.type";
import { IVehicle } from "interfaces/session/IVehicle";
import { useRouter } from "next/router";
import { CSSProperties, memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import HideIf from "util/HideIf";
import { getValidCategory } from "util/category/get-valid-category";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import { PAGE_TYPES } from "util/product/product-constants";
import { refreshData } from "util/refreshData";
import styles from "./fitmentOptions.module.scss";

interface IProps {
  relevantSelectedFitmentOptions: {
    [key: string]: string;
  }
  fitmentOptionsDetails: IFitmentOptionsDetails;
  remainingFitmentOptions: string[];
  style: CSSProperties;
  expanded: boolean;
}

function FitmentOptions(props: IProps) {
  const {
    fitmentOptionsDetails, style,
    product, validateFitment, selectVehicleSettings,
    expanded = true,
  } = props;

  const dispatch = useDispatch();
  const { selectedVehicle } = useSelector((state: RootState) => state.garage);
  const { selectedId } = useSelector((state: RootState) => state.modal);
  const { currentPageType } = useSelector((store: RootState) => store.utils);
  const router = useRouter();
  const { pathname } = router.query;
  const [isMobile] = useScreenSize();

  const { relevantSelectedFitmentOptions, remainingFitmentOptions, requireFullVehicleSelection } = product;

  const selectionOrder = currentPageType === PAGE_TYPES.PRODUCT_MAKE_MODEL_PAGE ? MAKE_MODEL_YEAR : YEAR_MAKE_MODEL;

  const defaultVehicle = {
    ...{
      defaultMake: selectedVehicle?.make,
      defaultModel: selectedVehicle?.model,
      defaultYear: selectedVehicle?.year,
    },
  };

  let objectKeys = Object.keys(relevantSelectedFitmentOptions || {});
  objectKeys.unshift(...remainingFitmentOptions);
  objectKeys = isMobile && !expanded ? objectKeys.slice(0, 2) : objectKeys;
  objectKeys = objectKeys.filter((_) => _ !== "vcdb.TireSizeAndPosition"); // temporary fix to hide this FO on product card

  if (!relevantSelectedFitmentOptions || objectKeys.length === 0 || !fitmentOptionsDetails) {
    return null;
  }

  function clientSideRefresh(vehicle: IVehicle) {
    return refreshData({
      pathname,
      isMobile,
      selectedVehicle: vehicle,
    });
  }

  const FitmentValueDetails = (valueProps: any) => {
    const { fitmentOptions = [] } = valueProps;

    return (

      fitmentOptions.map((optionName, index) => {
        const fitmentOptionDetail = fitmentOptionsDetails[optionName];
        const { iconUrl, title, fitmentOptionValues } = fitmentOptionDetail || {};
        const attributeTitle = fitmentOptionsDetails[optionName]?.title;
        const imgSrc = getRelativeImagePath(iconUrl);

        return (

          <div
            key={index}
            className={styles.fitment_values_container}
            style={fitmentOptions.length <= 1 ? { border: "none" } : {}}
          >

            <div>
              <PAImage
                src={imgSrc}
                width={22}
                height={22}
                alt={title}
                className={styles.fitment_icon}
              />
            </div>

            <div className="d-flex flex-column" style={{ width: "80%", flexGrow: "1" }}>
              <div className="d-flex align-items-center fitment_options_title_container">
                <div className={styles.fitment_values}>

                  <HideIf show={relevantSelectedFitmentOptions[optionName]}>
                    <PAText>
                      {relevantSelectedFitmentOptions[optionName]}
                    </PAText>
                  </HideIf>

                </div>
                <HideIf show={relevantSelectedFitmentOptions[optionName]}>
                  <div
                    className={styles.fitment_change_icon}
                    data-testid="edit-fitment-icon"
                    onClick={() => dispatch(openModal("vehicleSelector", {
                      defaultMake: selectedVehicle.make,
                      defaultModel: selectedVehicle.model,
                      defaultYear: selectedVehicle.year,
                      fitmentOptionsPrompt: [optionName],
                      fitmentOptionsDetails,
                      clientSideRefresh,
                      forceTrigger: true,
                      requireFullVehicleSelection,
                    }))}
                  >
                    <i className="fa fa-pencil " />
                  </div>
                </HideIf>

              </div>
              <HideIf show={remainingFitmentOptions.includes(optionName) && selectedId !== "vehicleSelector" && !requireFullVehicleSelection}>
                <div className={styles.vehicle_selector_container} key={optionName}>
                  <VehicleSelectorForm
                    {...defaultVehicle}
                    selectionOrder={selectionOrder}
                    attributeOptions={fitmentOptionValues}
                    // autoFocus
                    focusEl={optionName}
                    category={getValidCategory(product)}
                    onSelectVehicle={(newVehicle: any) => {
                      dispatch(addVehicle(newVehicle, true));
                    }}
                    selectFitmentOptionOneByOne
                    attributeTitle={attributeTitle}
                    validateFitment={validateFitment}
                    selectVehicleSettings={selectVehicleSettings}
                    product={product}
                  />
                </div>
              </HideIf>
            </div>

          </div>

        );
      })

    );
  };

  return (
    <div className={styles.container} style={style}>
      <div className={styles.fitment_detail_container}>
        <FitmentValueDetails fitmentOptions={objectKeys} />
      </div>
    </div>

  );
}

export default memo(FitmentOptions);
